import React, { useEffect } from "react";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import Routes from "./routes/Routes";
import "./i18n";
import { QueryClient, QueryClientProvider } from "react-query";
import { EXPONENTIAL_BACKOFF, RETRY_COUNT } from "./appConstants/AppConstant";
import Toast from "./components/Toast/toast";
import { persistor, store } from "./store";
import { setNavigateFunction } from "./utils/helpers/NavigationService";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { GoogleOAuthProvider } from '@react-oauth/google';
import CleverTapScript from "./components/CleverTapInit";
import FbPixel from "./utils/FbPixel/fbPixel";
import { getPartnerId } from "./utils/helpers/common";
import { FACEBOOK } from "./utils/helpers/constants";

const InitializeNavigation = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigateFunction(navigate);
  }, [navigate]);
  return null;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 60 * 1000,
      retry: RETRY_COUNT,
      retryDelay: (failureCount) =>
        (EXPONENTIAL_BACKOFF[failureCount] || 1) * 1000,
    },
  },
});

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}>
        <ReduxProvider store={store}>
          <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
            <QueryClientProvider client={queryClient}>
              <main className="main">
                <Toast />
                <CleverTapScript limit={100} />
                {getPartnerId() === FACEBOOK && <FbPixel />}
                <Router>
                  <InitializeNavigation />
                  <Routes />
                </Router>
              </main>
            </QueryClientProvider>
          </PersistGate>
        </ReduxProvider>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  );
};

export default App;
